import { combineReducers } from '@reduxjs/toolkit';

import selected from './selected';

/**
 * @typedef {{
 * selected: import('./selected').SelectedState,
 * }} TabsState
 */

export default combineReducers({
  selected,
});
